import ArrowInformationBox from './ArrowInformationBox';

export default ArrowInformationBox;
